// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"RciOY0ZTdB4ljK+PwzCDxg==","leftCol":"Ppg9u7n-n4jZN1FtSIEQjg==","rightCol":"cLzR08oIquSTNjbCks2RJQ=="};